// User waypoints layer family.
//
// Extracted from addOverlays.ts as HI-1 batch 5 (audit 2026-05-22).
// Pure mechanical move — every source, layer, paint expression,
// layout property, and minzoom/maxzoom is byte-identical to its
// pre-extraction form. Source-id idempotency guard preserved.
//
// Uses the LayerFamilySpec shape introduced in batch 9.

import type { Map as MlMap } from 'maplibre-gl';
import { EMPTY_FC } from '../MapView';
import { ensureUserWaypointIcons } from '../userWaypointIcons';
import { registerLayerFamily } from '../layerVisibilityRegistry';

/**
 * Mount the user-waypoints source + its layers. Idempotent on the source.
 */
export function addUserWaypointsLayers(map: MlMap): void {
    if (!map.getSource('user-waypoints')) {
      map.addSource('user-waypoints', { type: 'geojson', data: EMPTY_FC });
      void ensureUserWaypointIcons(map);
      map.addLayer({
        id: 'user-waypoints-symbol',
        type: 'symbol',
        source: 'user-waypoints',
        layout: {
          'icon-image': 'wpt-flag',
          'icon-size': [
            'interpolate', ['linear'], ['zoom'],
            6, 0.7,
            10, 1.0,
            14, 1.4,
          ],
          'icon-allow-overlap': true,
          'icon-ignore-placement': true,
          'text-field': ['get', 'name'],
          'text-size': 10,
          'text-offset': [0, 1.2],
          'text-anchor': 'top',
          'text-font': ['Noto Sans Regular'],
        },
        paint: {
          'text-color': '#fb923c',  // ember-400
          'text-halo-color': '#0b0d0f',
          'text-halo-width': 1.2,
        },
      });
    }
}

registerLayerFamily({
  id: 'user-waypoints',
  label: 'User waypoints',
  sourceId: 'user-waypoints',
  layerIds: ['user-waypoints-symbol'],
  mount: (map) => addUserWaypointsLayers(map),
  // No applyState needed: user waypoints are always visible (no toggle).
  // The MapView user-waypoints subscribe effect handles data pushes;
  // mount() ensures the source + layer survive basemap rebuilds.
});
